import type { Content } from '../../interface/Content';
import type { Paginated } from '@/interfaces/Paginate';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getKeepWatching = async (context: Context, types?: string) => {
  try {
    const { data } = await api.get<Paginated<Content>>(mapContext[context], {
      params: { types },
    });
    return data.data;
  } catch {
    return [];
  }
};

export const useGetKeepWatching = (
  context: Context = 'home',
  types?: string
) => {
  const { data: session } = useSession();
  return useQuery({
    queryKey: ['keep', 'watching', context, types],
    queryFn: () => getKeepWatching(context, types),
    enabled: !!session && !!session.access_token,
  });
};

const mapContext = {
  home: apiConfig.routes.entertainment.content.keepWatching,
  research: apiConfig.routes.research.keepWatch,
} as const;

type Context = keyof typeof mapContext;
